import { render, staticRenderFns } from "./BooleanData.vue?vue&type=template&id=25d2dec5&scoped=true&"
import script from "./BooleanData.vue?vue&type=script&lang=js&"
export * from "./BooleanData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d2dec5",
  null
  
)

export default component.exports